import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button } from "@shared/ui/button";
import { Label } from "@shared/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { useActiveUtilityServices } from "@shared/hooks/useActiveUtililyServices";
import { useCategories } from "@features/onboarding/utility-setup/hooks";
import { planFilters } from "@features/onboarding/utility-setup/types";
interface FilterPanelProps {
  currentFilters: planFilters;
  onApplyFilters: (filters: Partial<planFilters>) => void;
  onResetFilters: () => void;
}

export const FilterPanel: React.FC<FilterPanelProps> = ({
  currentFilters,
  onApplyFilters,
  onResetFilters,
}) => {
  const queryClient = useQueryClient();



  const { data: activeUtilityServices, isLoading: loadingUtilityServices } =
    useActiveUtilityServices();

  const { data: categories, isLoading: loadingCategories } = useCategories();
  console.log('categories',categories)

  const form = useForm({
    defaultValues: {
      utility_service: currentFilters.utilityService || "ALL_SERVICES",
      category: currentFilters.category || "ALL_CATEGORIES",
    },
  });

  const handleApplyFilters = (data: any) => {
    console.log('handleApplyFilters',data)
    const filtersToApply: Partial<planFilters> = {};

    if (data.utility_service && data.utility_service !== "ALL_SERVICES") {
      filtersToApply.utilityService = data.utility_service;
    }

    if (data.category && data.category !== "ALL_CATEGORIES") {
      filtersToApply.category = data.category;
    }

    onApplyFilters(filtersToApply);
  };

  const handleResetFilters = () => {
    form.reset({
    
      utility_service: "ALL_SERVICES",
      category: "ALL_CATEGORIES",
    });
    onResetFilters();
  };

  return (
    <form onSubmit={form.handleSubmit(handleApplyFilters)}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
        {/* Utility Service */}
        <div className="space-y-2">
          <Label>Utility Service</Label>
          <Controller
            name="utility_service"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select utility service" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="ALL_SERVICES">All Services</SelectItem>
                    {activeUtilityServices?.map((service) => (
                      <SelectItem key={service.name} value={service.name}>
                        {service.name}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
        </div>

        {/* Category */}
        <div className="space-y-2">
          <Label>Category</Label>
          <Controller
            name="category"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select category" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="ALL_CATEGORIES">
                      All Categories
                    </SelectItem>
                    {categories?.map((cat) => (
                      <SelectItem key={cat.code} value={cat.code}>
                        {cat.name}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
        </div>

        {/* Actions */}
        <div className="col-span-1 md:col-span-2 lg:col-span-2 flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={handleResetFilters}>
            Reset Filters
          </Button>
          <Button type="submit">Apply Filters</Button>
        </div>
      </div>
    </form>
  );
};

